import { prefersReducedMotion } from '@theme/utilities';

/**
 * Initialise les animations de texte basées sur l'IntersectionObserver
 */
function initTextAnimations() {
  if (prefersReducedMotion()) {
    return; // Ne pas animer si l'utilisateur préfère réduire les animations
  }

  const animatedElements = document.querySelectorAll('[data-text-animation]');
  
  if (animatedElements.length === 0) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('text-animated-visible');
          
          // Si l'animation ne doit pas se répéter, arrêter d'observer
          const shouldRepeat = entry.target.dataset.animationRepeat === 'true';
          if (!shouldRepeat) {
            observer.unobserve(entry.target);
          }
        } else {
          // Si l'animation doit se répéter, retirer la classe visible quand l'élément sort de la vue
          const shouldRepeat = entry.target.dataset.animationRepeat === 'true';
          if (shouldRepeat) {
            entry.target.classList.remove('text-animated-visible');
          }
        }
      });
    },
    {
      threshold: 0.2, // Déclencher quand 20% de l'élément est visible
      rootMargin: '0px 0px -50px 0px' // Déclencher un peu avant que l'élément soit complètement visible
    }
  );

  animatedElements.forEach((element) => {
    observer.observe(element);
  });
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTextAnimations);
} else {
  initTextAnimations();
}

// Réinitialiser après les transitions de page (pour Shopify)
document.addEventListener('shopify:section:load', initTextAnimations);

